import type { Theme } from "@mui/material"
import { GlobalNavigationItemTheme } from "core/themes/src/definitions/components.types"

export const createGlobalNavigationItemTheme = (theme: Theme): GlobalNavigationItemTheme => ({
    styleOverrides: {
        root: {
            "&.user-settings": {
                border: "1px solid #0063c3",
                opacity: theme.opacity?.primary || ".87",
            },
            "&.active": {
                "border-color": "#f6f6f6",
                opacity: "1",
            },
            "&:hover:not(.active)": {
                background: "hsla(0, 0%, 100%, .15)",
                " svg": {
                    opacity: theme.opacity?.primary || ".87",
                },

                " img": {
                    opacity: theme.opacity?.primary || ".87",
                },
            },
        },
        icon: {
            opacity: theme.opacity?.primary || ".87",
            "&:hover": {
                opacity: theme.opacity?.primary || ".87",
            },
            ".active > &": {
                opacity: theme.opacity?.primary || ".87",
            },

            "&.icon-user-settings": {
                opacity: 1, // tokic has a settings button which already has an opacity
            },
        },
        image: {
            opacity: theme.opacity?.primary || ".87",
            "&:hover": {
                opacity: theme.opacity?.primary || ".87",
            },
            ".active > &": {
                opacity: theme.opacity?.primary || ".87",
            },
        },
    },
})
